import { clsx } from 'clsx';
import { memo } from 'react';

import classes from './BottomPanelTile.module.scss';

interface BottomPanelTileProps {
  children: React.ReactNode;
  className?: string;
}

const BottomPanelTile = (props: BottomPanelTileProps) => {
  const { children, className } = props;

  return <div className={clsx(classes.BottomPanelTile, className)}>{children}</div>;
};

const MemoizedBottomPanelTile = memo(BottomPanelTile);

export default MemoizedBottomPanelTile;
